import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const SOCIALS = [
  { label: "GitHub", href: "https://github.com/ellenboakye" },
  { label: "LinkedIn", href: "https://www.linkedin.com/in/boakyeellen" },
];

const LINKS = [
  { label: "Projects", to: "/projects" },
  { label: "Certificates", to: "/certificates" },
  { label: "Gallery", to: "/gallery" },
  // { label: "CV", to: "/cv" }, // hidden
  { label: "About", to: { pathname: "/", hash: "#about" } },
  { label: "Contact", to: { pathname: "/", hash: "#contact" } },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.hash]);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  return (
    <>
      <header className="fixed inset-x-0 top-0 z-40 border-b border-line bg-paper/92 backdrop-blur">
        <div className="mx-auto flex max-w-content items-center justify-between px-6 py-5 md:px-12">
          <Link to="/" className="flex flex-shrink-0 items-center whitespace-nowrap" aria-label="Ellen Boakye, home">
            <span
              className="flex h-9 w-9 items-center justify-center rounded-full border border-line-strong font-serif text-[0.8rem] font-extrabold tracking-tight text-heading"
              aria-hidden="true"
            >
              EB
            </span>
          </Link>

          <nav className="hidden items-center gap-5 lg:flex">
            {LINKS.map((l) => (
              typeof l.to === "string" ? (
                <NavLink
                  key={l.label}
                  to={l.to}
                  className={({ isActive }) =>
                    `whitespace-nowrap text-[0.68rem] uppercase tracking-wide transition-colors ${
                      isActive ? "text-heading" : "text-ink-soft hover:text-heading"
                    }`
                  }
                >
                  {l.label}
                </NavLink>
              ) : (
                <Link
                  key={l.label}
                  to={l.to}
                  className="whitespace-nowrap text-[0.68rem] uppercase tracking-wide text-ink-soft transition-colors hover:text-heading"
                >
                  {l.label}
                </Link>
              )
            ))}
            <span className="h-3 w-px flex-shrink-0 bg-line-strong" aria-hidden="true" />
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noreferrer"
                className="whitespace-nowrap text-[0.68rem] uppercase tracking-wide text-ink-soft transition-colors hover:text-heading"
              >
                {s.label}
              </a>
            ))}
          </nav>

          <button
            className="flex flex-shrink-0 flex-col gap-[5px] p-1 lg:hidden"
            aria-label={open ? "Close menu" : "Open menu"}
            onClick={() => setOpen((v) => !v)}
          >
            <span className={`block h-px w-5 bg-heading transition-transform ${open ? "translate-y-[6px] rotate-45" : ""}`} />
            <span className={`block h-px w-5 bg-heading transition-opacity ${open ? "opacity-0" : ""}`} />
            <span className={`block h-px w-5 bg-heading transition-transform ${open ? "-translate-y-[6px] -rotate-45" : ""}`} />
          </button>
        </div>
      </header>

      {open && (
        <div className="fixed inset-x-0 bottom-0 top-[77px] z-30 flex flex-col justify-center gap-8 overflow-y-auto bg-paper px-10 py-8 lg:hidden">
          <Link to="/" onClick={() => setOpen(false)} className="font-serif text-3xl text-heading">Home</Link>
          {LINKS.map((l) => (
            <Link key={l.label} to={l.to} onClick={() => setOpen(false)} className="font-serif text-3xl text-heading">{l.label}</Link>
          ))}
          <div className="mt-4 flex gap-6">
            {SOCIALS.map((s) => (
              <a key={s.label} href={s.href} target="_blank" rel="noreferrer" className="text-xs uppercase tracking-widest2 text-ink-soft">
                {s.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
